<mat-icon
  [matTooltip]="tooltip"
  matTooltipPosition="above"
  color="primary"
  class="contact-icon vertical-align-middle font-18 marital-icon"
>
  group
</mat-icon>
